import { eventsApi } from '@/services/api/instances';

import {
  TrailFiltersResponseSchema,
  TrailListQuerySchema,
  TrailListResponseSchema,
  TrailNewEventsQuerySchema,
  TrailNewEventsResponseSchema,
  TrailSourcePathSchema,
} from '@/domain/events/schemas';

export const eventsTrailApi = {
  getTrail: eventsApi.endpoint({
    method: 'GET',
    url: (p: { source: string }) => p.source,
    path: TrailSourcePathSchema,
    query: TrailListQuerySchema,
    response: TrailListResponseSchema,
  }),

  getTrailFilters: eventsApi.endpoint({
    method: 'GET',
    url: (p: { source: string }) => `${p.source}/filters`,
    path: TrailSourcePathSchema,
    response: TrailFiltersResponseSchema,
  }),

  getTrailNewEvents: eventsApi.endpoint({
    method: 'GET',
    url: (p: { source: string }) => `${p.source}/count-new`,
    path: TrailSourcePathSchema,
    query: TrailNewEventsQuerySchema,
    response: TrailNewEventsResponseSchema,
  }),
};
